import { type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { HorizontalScrollView } from "../HorizontalScrollView";

export interface CalloutsWrapperProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function CalloutsWrapper(props: CalloutsWrapperProps) {
  const { children, sx } = props;

  return (
    <HorizontalScrollView
      stretch
      sx={mergeSxProps(
        {
          "& > *": {
            minWidth: "auto",
            width: "fit-content",
          },

          // If there are more than two callouts, let them take up the width they need.
          // We're setting min of 35% to make sure that they fill the whole width of the screen
          // and indicate there is more content to scroll
          "&:has(> :nth-child(3))": {
            "> *": {
              minWidth: "35%",
              width: "fit-content",
            },
          },

          // If there are exactly two callouts, display them side by side
          // filling the available space
          "&:has(> :nth-child(2):last-child) > *": {
            minWidth: "50%",
            width: "fit-content",
          },
        },
        sx
      )}
    >
      {children}
    </HorizontalScrollView>
  );
}
